export default __webpack_public_path__ + "images/b5e51396f0c771217bc9f2bf17a971ff-next.svg";